import { config } from '@/config';
// import { Embedded } from '@/constants/enum';
import { IParamsApi } from '@/types/apis/params';
import { IResponseApi } from '@/types/apis/response';
import { IPreview } from '@/types/components/preview';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { createApp } from '@shopify/app-bridge';
// import { getSessionToken } from '@shopify/app-bridge-utils';
// import authSlice from '../slice/auth.slice';
import { ISetupCheckoutVerify } from '../slice/checkoutVerification.slice';
// import store from '../store';
import { TermsType } from './../../constants/enum';

const params = {
  shop: config.shop,
};
// const configApp = {
//   apiKey: process.env.REACT_APP_API_KEY || '',
//   host: new URLSearchParams(window.location.search).get('host') || '',
//   forceRedirect: process.env.REACT_APP_MODE === 'live',
// };
export const apiCaller = createApi({
  reducerPath: 'apiCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_END_POINT,
    prepareHeaders: async (headers) => {
      // if (config.embedded === Embedded.LIVE) {
      //   if (
      //     (!store.getState().auth.token || Date.now() > store.getState().auth.expiredTime) &&
      //     !store.getState().auth.isLoading
      //   ) {
      //     try {
      //       store.dispatch(authSlice.actions.handleLoading(true));
      //       const app = createApp(configApp);
      //       const sessionToken = await getSessionToken(app);
      //       store.dispatch(
      //         authSlice.actions.handleToken({
      //           token: sessionToken,
      //           expiredTime: Date.now() + 60 * 1000,
      //           isLoading: false,
      //         }),
      //       );
      //       headers.set('authorization', `Bearer ${sessionToken}`);
      //     } catch (err) {
      //       store.dispatch(authSlice.actions.handleLoading(false));
      //     }
      //   }
      //   if (store.getState().auth.token) {
      //     headers.set('authorization', `Bearer ${store.getState().auth.token}`);
      //   }
      // }

      // if (process.env.REACT_APP_ENV === 'production') {
      //   headers.set('Content-Security-Policy', `frame-ancestors https://${params.shop} https://admin.shopify.com`);
      // }
      // headers.set('authorization-url-params', config.urlParams);

      return headers;
    },
  }),
  tagTypes: [
    'general',
    'preview',
    'overview',
    'language',
    'translation',
    'checkout_verify',
    'popup',
    'rule_name',
    'preview_label',
    'month_label',
    'term_and_condition',
    'plan',
    'total_rule_active',
  ],
  // get data settings
  endpoints: (builder) => ({
    getGeneralDetail: builder.query<IResponseApi.GeneralDetail, string | undefined>({
      query: () => {
        return {
          url: `shop/general-setting`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'general' }],
    }),
    updateAppStatus: builder.mutation<IResponseApi.CommonResponse, boolean>({
      query: (input) => {
        return {
          url: `settings/status-app`,
          method: 'PUT',
          params: { ...params },
          body: {
            appStatus: input,
            shop: params.shop,
          },
        };
      },
      invalidatesTags: [{ type: 'general' }],
    }),
    updateAppSettings: builder.mutation<IResponseApi.CommonResponse, IParamsApi.IShopSetting | undefined>({
      query: (input) => {
        return {
          url: `shop/settings`,
          method: 'PUT',
          params: { ...params },
          body: {
            ...input,
            shop: params.shop,
          },
        };
      },
      invalidatesTags: [{ type: 'general' }],
    }),
    checkAppEmbedStatus: builder.query<{ status: boolean; deepLinkUrl: string; debugSnippet?: unknown }, void>({
      query: () => {
        return {
          url: 'shopline/check-app-extension',
          method: 'GET',
          params: { ...params },
        };
      },
    }),
    getOverview: builder.query<IResponseApi.IOverview, IParamsApi.IOverview>({
      query: (input) => {
        return {
          url: `analytics`,
          method: 'GET',
          params: { ...params, startDate: input.startDate, endDate: input.endDate },
        };
      },
      providesTags: [{ type: 'overview' }],
    }),

    getShopDomain: builder.query<IResponseApi.IDomain, undefined>({
      query: () => {
        return {
          url: `shop/domain`,
          method: 'GET',
          params: { ...params },
        };
      },
    }),

    uploadImage: builder.mutation<IResponseApi.IUploadImage, FormData>({
      query: (image) => {
        return {
          url: `file/upload-image`,
          method: 'POST',
          body: image,
          params: { ...params },
        };
      },
    }),

    getRuleName: builder.query<IResponseApi.IRuleName, void>({
      query: () => {
        return {
          url: `settings/rule-name`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'rule_name' }],
    }),

    updateTemplate: builder.mutation<IResponseApi.IUpdateTemplate, IPreview>({
      query: (input) => {
        return {
          url: `settings`,
          method: 'PUT',
          params: { ...params },
          body: input,
        };
      },
      invalidatesTags: [{ type: 'popup' }, { type: 'rule_name' }, { type: 'total_rule_active' }, { type: 'preview' }],
    }),

    getSettings: builder.query<IResponseApi.IGetSettings, string>({
      query: (input) => {
        return {
          url: 'settings',
          method: 'GET',
          params: { ...params, id: input },
        };
      },
      providesTags: [{ type: 'preview' }],
    }),

    getPopupList: builder.query<IResponseApi.IPopupList, IParamsApi.IPopupList>({
      query: (input) => {
        return {
          url: 'settings/all',
          method: 'GET',
          params: { ...params, ...input },
        };
      },
      providesTags: [{ type: 'popup' }],
    }),

    deleteRule: builder.mutation<IResponseApi.CommonResponse, string>({
      query: (input) => {
        return {
          url: `settings`,
          method: 'DELETE',
          params: { ...params, ids: input },
        };
      },
      invalidatesTags: () => {
        return [{ type: 'popup' }, { type: 'rule_name' }, { type: 'translation' }, { type: 'total_rule_active' }];
      },
    }),

    deleteAllRule: builder.mutation<IResponseApi.CommonResponse, void>({
      query: () => {
        return {
          url: `settings/all`,
          method: 'DELETE',
          params: { ...params },
        };
      },
      invalidatesTags: [{ type: 'popup' }, { type: 'rule_name' }, { type: 'translation' }, { type: 'total_rule_active' }],
    }),

    updateSetupCheckoutVerify: builder.mutation<IResponseApi.CommonResponse, ISetupCheckoutVerify>({
      query: (input) => {
        return {
          url: `settings/checkout`,
          method: 'PUT',
          params: { ...params },
          body: input,
        };
      },
      invalidatesTags: [{ type: 'checkout_verify' }, { type: 'total_rule_active' }],
    }),

    getSetupCheckoutVerify: builder.query<IResponseApi.IGetSetupCheckoutVerify, void>({
      query: () => {
        return {
          url: 'settings/checkout',
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'checkout_verify' }],
    }),

    updateTermAndCondition: builder.mutation<
      IResponseApi.CommonResponse,
      IParamsApi.ISetupTermAndCondition | IParamsApi.ISetupTermAndConditionCheckoutUI
    >({
      query: (input) => {
        return {
          url: `terms/upsert`,
          method: 'POST',
          params: { ...params },
          body: input,
        };
      },
      invalidatesTags: [{ type: 'term_and_condition' }, { type: 'total_rule_active' }],
    }),

    getTermAndCondition: builder.query<IResponseApi.ITermAndCondition, { type: TermsType }>({
      query: (input) => {
        return {
          url: 'terms/details',
          method: 'GET',
          params: { ...params, type: input.type },
        };
      },
      providesTags: [{ type: 'term_and_condition' }],
    }),

    getPages: builder.query<IResponseApi.IGetPages, void>({
      query: () => {
        return {
          url: 'shopify/pages',
          method: 'GET',
          params: { ...params },
        };
      },
    }),
    trackAction: builder.mutation<void, string>({
      query: (event) => {
        return {
          url: 'tracking',
          method: 'POST',
          params: { ...params },
          body: {
            shop: params.shop,
            event,
          },
        };
      },
    }),

    getProducts: builder.query<IResponseApi.IGetProductList, { search: string; isGiftCard?: boolean }>({
      query: (input) => {
        return {
          url: `shopline/products/search`,
          method: 'GET',
          params: { ...params, ...input },
        };
      },
    }),

    getCollections: builder.query<IResponseApi.IGetCollectionList, { search: string }>({
      query: (input) => {
        return {
          url: `shopline/collections/search`,
          method: 'GET',
          params: { ...params, ...input },
        };
      },
    }),

    getLanguage: builder.query<IResponseApi.ILanguages, { shop: string }>({
      query: (input) => {
        return {
          url: `shopify/shop-locales`,
          method: 'GET',
          params: { ...params, ...input },
        };
      },
      providesTags: [{ type: 'language' }],
    }),
    getTranslation: builder.query<IResponseApi.ITranslations, { page?: number; limit?: number }>({
      query: (input) => {
        return {
          url: `translation/all`,
          method: 'GET',
          params: { ...input, ...params },
        };
      },
      providesTags: [{ type: 'translation' }],
    }),
    getSingleTranslation: builder.query<IResponseApi.ISingleTranslationRes, { id: undefined | string }>({
      query: (input) => {
        return {
          url: `translation`,
          method: 'GET',
          params: { ...params, ...input },
        };
      },
      providesTags: (result, error, { id }) => [{ type: 'translation', id }],
    }),
    updateTranslation: builder.mutation<IResponseApi.ITranslations, IParamsApi.IUpdateTranslation>({
      query: (input) => {
        return {
          url: `translation`,
          method: 'POST',
          params: { ...params },
          body: {
            shop: params.shop,
            ...input,
          },
        };
      },
      invalidatesTags: (result, error, input) => [
        { type: 'translation', id: input.id },
        { type: 'translation' },
        { type: 'total_rule_active' },
      ],
    }),
    deleteTranslation: builder.mutation<IResponseApi.CommonResponse, { ids: string[] }>({
      query: (input) => {
        return {
          url: `translation`,
          method: 'DELETE',
          params: { ...params, ids: JSON.stringify(input.ids) },
        };
      },
      invalidatesTags: [{ type: 'translation' }, { type: 'total_rule_active' }],
    }),
    getPreviewLabel: builder.query<IResponseApi.IPreviewLabel, { id: string }>({
      query: (input) => {
        return {
          url: `settings/preview-label`,
          method: 'GET',
          params: { ...params, ...input },
        };
      },
      providesTags: (result, error, input) => [{ type: 'preview_label', id: input.id }],
    }),
    getMonthLabel: builder.query<IResponseApi.IMonthLabel, undefined>({
      query: () => {
        return {
          url: `settings/month-label`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'month_label' }],
    }),
    fetchGA: builder.mutation<IResponseApi.CommonResponse, IParamsApi.IGA4>({
      query: (input) => {
        return {
          url: `tracking/ga4`,
          method: 'POST',
          params: { ...params },
          body: { ...input },
        };
      },
    }),

    // Start Plan Pricing
    getPlans: builder.query<IResponseApi.IListPricing, void>({
      query: () => {
        return {
          url: `app-pricing`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'plan' }],
    }),

    getLinkChargePlan: builder.mutation<IResponseApi.IGetLinkChargePlan, IParamsApi.ILinkAccountPlan>({
      query: (input) => {
        return {
          url: 'app-pricing/get-link-account-plan',
          method: 'GET',
          params: {
            ...params,
            subscription: input.subscription,
            plan: input.plan,
          },
        };
      },
      invalidatesTags: [
        { type: 'general' },
        { type: 'total_rule_active' },
        { type: 'popup' },
        { type: 'translation' },
        { type: 'rule_name' },
      ],
    }),

    getTotalRuleActive: builder.query<IResponseApi.IGetTotalRuleActive, void>({
      query: () => {
        return {
          url: `shop/total-rule`,
          method: 'GET',
          params: { ...params },
        };
      },
      providesTags: [{ type: 'total_rule_active' }],
    }),

    applyDiscountCode: builder.mutation<IResponseApi.CommonResponse, string>({
      query: (discountCode) => {
        return {
          url: 'promotion/apply-discount-code',
          method: 'PUT',
          params: { ...params },
          body: { shop: params.shop, code: discountCode },
        };
      },
      invalidatesTags: [{ type: 'plan' }],
    }),
    // End Plan Pricing

    translateWithAI: builder.mutation<IResponseApi.ITranslateWithAI, IParamsApi.ITranslateWithAI>({
      query: (input) => {
        return {
          url: `translation/translate-with-ai`,
          method: 'POST',
          params: { ...params },
          body: { ...input },
        };
      },
    }),
  }),
});
